import { methods, ServiceMaker } from './index';

const { POST } = methods;

export const verify = data => ServiceMaker(`/v1/api/pg/order/verify-mq`, POST,null,data);